/* eslint-disable no-console */
import axios from "axios";
import { createBrowserHistory } from "history";
/* Create axios instance */
const api = axios.create({
    baseURL: "/",
    headers: {
        "Cache-Control": "no-cache",
        "Content-Type": "application/json",
        "X-Platform": "web",
    },
    xsrfCookieName: "STRATUS-XSRF-TOKEN",
    xsrfHeaderName: "STRATUS-XSRF-TOKEN",
});

const STAGED_UPLOAD_ROUTES =
    /^\/?(v2\/upload-application-files|uploads\/\d+|addnote\/\d+|v2\/add-note-thankyou|create-organization|update-organization\/\d+|sub-organizations|edit-sub-organizations|v2\/conditional-addendums\/cbd|org-contract\/store|save-equipment-brand|save-update-equipments|payliance\/upload-document|v2\/service-ticket\/(create|add-comment))\/?$/;

const stageFiles = async (config) => {
    const entries = [];
    config.data.forEach((value, key) => entries.push([key, value]));
    const files = entries.map(([, value]) => value).filter((value) => value instanceof Blob);
    if (!files.length) {
        return config.data;
    }

    const { uploads } = await api.post(
        "/v2/staged-uploads",
        {
            editslug: config.data.get("editslug") || undefined,
            files: files.map((file) => ({ name: file.name, type: file.type })),
        },
        config.headers.OtpCode ? { headers: { OtpCode: config.headers.OtpCode } } : {},
    );

    const tokens = await Promise.all(
        uploads.map(async ({ url, fields, token }, n) => {
            const form = new FormData();
            Object.entries(fields).forEach(([name, value]) => form.append(name, value));
            form.append("file", files[n]);
            const response = await fetch(url, { method: "POST", body: form });
            if (!response.ok) {
                throw new Error("File upload failed.");
            }
            return token;
        }),
    );

    const staged = new FormData();
    let n = 0;
    entries.forEach(([key, value]) => {
        if (value instanceof Blob) {
            staged.append(key.replace(/^([^[]+)/, "_staged_files[$1]"), tokens[n++]);
        } else {
            staged.append(key, value);
        }
    });
    return staged;
};

api.interceptors.request.use(
    async (config) => {
        config.baseURL = "/";
        if (config.data instanceof FormData && STAGED_UPLOAD_ROUTES.test(config.url)) {
            config.data = await stageFiles(config);
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    },
);

api.interceptors.response.use(
    (response) => {
        return response.data;
    },
    (error) => {
        if (error?.response?.status === 401 || error?.response?.status === 419) {
            localStorage.clear();
            const history = createBrowserHistory({ forceRefresh: true });
            if (checkUnauthRoute(history.location.pathname) === false) {
                history.push("/");
            }
        }
        const generic_error = "Something went wrong.";

        /**
         * API sends an error message in the format
         * { error: error_message }
         */
        if (error.response && error.response.data) {
            /**
             * If the error is NOT initiated from the API (ie: for express/cloudflare errors)
             * then use generic error message for toast message and pass error info to sentry
             */
            if (typeof error.response.data === "string") {
                const newData = {
                    error: generic_error,
                    info: error.response.data,
                };
                return Promise.reject(newData);
            }
            return Promise.reject(error.response);
        }

        if (error.message === "Network Error") {
            error.message = offline_error;
        }
        return Promise.reject(error.message);
    },
);

function checkUnauthRoute(params) {
    if (
        params == "/" ||
        params == "/forgotPassword" ||
        params.includes("changePassword") ||
        params.includes("create-blank-app") ||
        params.includes("application/") ||
        params.includes("app/")
    ) {
        return true;
    } else {
        return false;
    }
}
export default api;
